import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

const edit = {
	BarvaId: null as number | null,
	BarvaKodGar: null as string | null,
	BarvaKodObjed: null as string | null,
	BarvaKodVyroba: null as string | null,
	LakdruhOzn: null as string | null,
	LakdruhOznText: null as string | null,
	Text: null as string | null,
	VyrobekvozOzn: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: { VyrobekvozOzn: [] },
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[types.mutations.BARVA_LAK_DRUH_SELECT_MAPPER](state, { data }) {
			state.edit.LakdruhOzn = data.value;
			state.edit.LakdruhOznText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
